import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { constants, CarePlan } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface TranslateCarePlanParams {
  targetLanguage: constants.LanguageCode;
}

interface TranslateCarePlanResponse {
  carePlan: CarePlan;
}

export const useTranslateCarePlan = ({
  patientId,
  encounterId,
  carePlanId,
  onSuccess,
  onError,
}: {
  patientId: string;
  encounterId: string;
  carePlanId: string;
  onSuccess?: (carePlan: CarePlan) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<TranslateCarePlanResponse, TranslateCarePlanParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.TRANSLATE({
        patientId,
        encounterId,
        carePlanId,
      }),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/charting/careplan/${carePlanId}/translations`,
          params,
        );
      },
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
        onSuccess?.(data.carePlan);
      },
      onError: (error) => {
        onError?.(error);
      },
    },
  });
};
